import { CONFIG } from '../../../../../config/mainConfig';
import { BookModel, IPageDataImageModel } from '../../../../../interfaces/book.interface';
import { IStoryData } from '../../../../../store/storySlice';

interface HandlePortraitUpdateProps {
  storyData: IStoryData;
  bookData: BookModel | null;
  library: any[];
  setCurrentPortrait: (portrait: string) => void;
  setCurrentPortraitList: (portraits: string[]) => void;
}

const getMappedImages = (images: Array<IPageDataImageModel>) => {
  return images?.length ? images.map((img) => img.imageURL) : [];
};

const handlePortraitUpdate = ({
                                storyData,
                                bookData,
                                library,
                                setCurrentPortrait,
                                setCurrentPortraitList
                              }: HandlePortraitUpdateProps) => {
  const illustrationCharacter = storyData?.illustrationCharacter;
  const bookIllustration = bookData?.illustrationCharacter;
  const setPortraitAndList = (portrait: string, list: string[] = []) => {
    setCurrentPortrait(portrait);
    setCurrentPortraitList(list);
  };

  if (bookIllustration && bookIllustration?.pageIndex === illustrationCharacter?.pageIndex &&
    illustrationCharacter?.isPortraitDeleted === false
  ) {
    setPortraitAndList(bookIllustration?.characterPortrait!, bookIllustration?.currentCharacterPortraitList || []);
  } else if (illustrationCharacter?.pageData?.imagePromptCharacterUrl &&
    illustrationCharacter?.isPortraitDeleted === false &&
    illustrationCharacter?.newRefImageUploaded === false
  ) {
    setPortraitAndList(illustrationCharacter?.pageData?.imagePromptCharacterUrl, getMappedImages(illustrationCharacter.pageData?.images || []));
  } else if (!bookIllustration && !illustrationCharacter?.pageIndex && storyData?.uploadedImage &&
    storyData?.regeneratedNewCharacter === false &&
    illustrationCharacter?.isPortraitDeleted === false
  ) {
    setPortraitAndList(storyData?.uploadedImage!, []);
  } else if (illustrationCharacter?.pageIndex && illustrationCharacter?.newRefImageUploaded === true
  ) {
    setPortraitAndList(storyData?.uploadedImage!, []);
  } else if (illustrationCharacter?.isPortraitDeleted === true || !bookData?.characterPortrait && !bookData?.uploadedImageUrl) {
    setPortraitAndList(CONFIG.CHARACTER.DUMMY_IMAGE, []);
  } else if (
    (illustrationCharacter?.pageData?.imagePromptCharacterUrl && !illustrationCharacter?.uploadedImage &&
      bookIllustration === null && illustrationCharacter?.isPortraitDeleted === false)
  ) {
    const characterId = library.find(characterImage => characterImage.characterUrl === illustrationCharacter?.pageData?.imagePromptCharacterUrl)?.characterId;
    const listImages = characterId ? library.filter(characterImage => characterImage.characterId === characterId).map(characterImage => characterImage.characterUrl) : [];
    setPortraitAndList(illustrationCharacter?.pageData?.imagePromptCharacterUrl, listImages);
  } else if (!illustrationCharacter?.pageIndex && bookData?.characterPortrait && bookData?.currentCharacterPortraitList?.length) {
    setPortraitAndList(bookData.characterPortrait, bookData.currentCharacterPortraitList);
  }
};

export default handlePortraitUpdate;
